export const PDF_ACTION_TYPE = {
  ON_ZOOM_IN: 'ON_ZOOM_IN',
  ON_ZOOM_OUT: 'ON_ZOOM_OUT',
  ON_ZOOM_FIT: 'ON_ZOOM_FIT',
  ON_PDF_ROTATE: 'ON_PDF_ROTATE',
  ON_EXPAND_TOGGLE: 'ON_EXPAND_TOGGLE',
  RESET_EXPANDED: 'RESET_EXPANDED'
};
export const CONTROL_ACTION_ICON = {
  ZOOM_IN: 'zoomIn',
  ZOOM_OUT: 'zoomOut',
  FULLSCREEN: 'fullscreen',
  ROTATE: 'rotate',
  EXPAND: 'expand',
  COLLAPSE: 'collapse',
  DOWNLOAD: 'download'
};